import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingBackButton: {
    id: 'charity.vetting.back.button',
    defaultMessage: 'Back',
  },
  charityVettingStepperNextButton: {
    id: 'charity.vetting.next.button',
    defaultMessage: 'Save and continue',
  },
  charityVettingStepperReviewButton: {
    id: 'charity.vetting.review.button',
    defaultMessage: 'Confirm details',
  },
  charityVettingLabelYes: {
    id: 'charity.vetting.label.yes',
    defaultMessage: 'Yes',
  },
  charityVettingLabelNo: {
    id: 'charity.vetting.label.no',
    defaultMessage: 'No',
  },
  charityVettingGenericNothingSelectedError: {
    id: 'charity.vetting.generic.nothing.selected.error',
    defaultMessage: 'Answer this question before you continue.',
  },
  charityVettingGenericCompleteAllFieldsError: {
    id: 'charity.vetting.generic.complete.all.fields',
    defaultMessage: 'Complete all the required fields before you continue.',
  },
  charityVettingDocumentRequiredError: {
    id: 'charity.vetting.document.required.error',
    defaultMessage: 'Upload this document before you continue.',
  },
  charityVettingDeclarationRequiredError: {
    id: 'charity.vetting.declaration.required.error',
    defaultMessage: 'Tick the box to continue.',
  },
});
